import { z } from 'zod';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { ModelContext } from 'libs/end-to-end/src/types/mlflow/types';

export const PromotionCopilotDropdowns = z
  .object({
    department: z.array(z.string()),
    job_title: z.array(z.string()),
    location: z.array(z.string()),
  })
  .describe('PromotionCopilotDropdowns');

export type PromotionCopilotDropdowns = z.infer<
  typeof PromotionCopilotDropdowns
>;

export const PromotionCopilotExtras = z
  .object({
    job_title_group_current: z.string().nullish(),
    produceExplanations: z.boolean().nullish(),
    modelContext: ModelContext,
    isExperimentalRun: z.boolean().optional(),
  })
  .describe('PromotionCopilotExtras');

export type PromotionCopilotExtras = z.infer<typeof PromotionCopilotExtras>;

export const PromotionCopilotInputs = z
  .object({
    dropdowns: PromotionCopilotDropdowns,
    extras: PromotionCopilotExtras,
  })
  .describe('PromotionCopilotInputs');

export type PromotionCopilotInputs = z.infer<typeof PromotionCopilotInputs>;

export const PromotionCopilotRequest = createCustomVizRequestSchema(
  'promotionCopilot',
  PromotionCopilotInputs,
);

export type PromotionCopilotRequest = z.infer<typeof PromotionCopilotRequest>;
